// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Models
import { AppCleanup } from '../../../shared/models';
import { UnitViewModel } from '../../asset/unit/models/unit-view.model';

@Injectable({
	providedIn: 'root',
})
export class DeviceService extends AppCleanup {
	private deviceUrl;
	domain: string = window.location.hostname;

	constructor(private http: HttpClient) {
		super();
		this.deviceUrl = `${this.apiUrl}api/device`;
	}

	getDevices() {
		return this.http.get<DeviceViewModel[]>(this.deviceUrl);
	}

	getDeviceUnits(deviceId: number) {
		return this.http.get<DeviceUnitViewModel[]>(`${this.deviceUrl}/${deviceId}/unit`);
	}

	createDeviceUnit(deviceId: number, deviceUnits: DeviceUnitModel[]) {
		return this.http.post<DeviceUnitViewModel[]>(`${this.deviceUrl}/${deviceId}/unit`, deviceUnits);
	}

	updateDeviceUnit(deviceId: number, unitGuid: string, deviceUnit: DeviceUnitModel) {
		return this.http.put<DeviceUnitViewModel>(`${this.deviceUrl}/${deviceId}/unit/${unitGuid}`, deviceUnit);
	}

	deleteDeviceUnit(deviceId: number, unitGuid: string) {
		return this.http.delete<DeviceUnitViewModel>(`${this.deviceUrl}/${deviceId}/unit/${unitGuid}`);
	}
}

export class DeviceViewModel {
	id?: number;
	name: string;
	machineName: string;
}

export class DeviceUnitModel {
	id?: number;
	deviceId: number;
	unitGuid: string;
	enabled: boolean;
}

export class DeviceUnitViewModel {
	id: number;
	device: DeviceViewModel;
	unit: UnitViewModel;
	enabled: boolean;
	isTemporaryUnit: boolean;
}
